import React, { useContext } from 'react';
import { getContext } from 'common';
import SelectItem, { SelectItemProps } from 'components/SelectItem';
import Tooltip, { TooltipProps } from 'components/Tooltip';
import { AppToolbarContext } from './';

import Styled from './styles';

export interface AppToolbarSelectItemProps extends React.ComponentPropsWithRef<'div'> {
  /** The items in the dropdown List. Consider using SelectListItem, SelectGroupHeading or any SelectItem sub-components. */
  children: React.ReactNode;
  /** Tooltip properties. See `Tooltip` component for details. */
  tooltipProps?: Partial<TooltipProps>;
  /** SelectItem properties. See `SelectItem` component for details.  */
  selectItemProps: Omit<SelectItemProps, 'children'>;
}

/** Formatted SelectItem for use on the AppToolbar.  */
const AppToolbarSelectItem = React.forwardRef<HTMLElement, AppToolbarSelectItemProps>((props: AppToolbarSelectItemProps, ref) => getContext(({ RTL }) => {
  const {
    tooltipProps,
    selectItemProps,
    children,
    ...otherProps
  } = props;
  const appToolbarContext: any = useContext(AppToolbarContext);

  return (
    <Tooltip
      placement="bottom"
      trigger={['hover', 'focus']}
      modifiers={{ offset: { offset: '0, 10' } }}
      tooltip=""
      disable={tooltipProps === undefined || !tooltipProps.tooltip}
      {...tooltipProps}
    >
      <Styled.AppToolbarSelectItem ref={ref} $rtl={RTL} $deviceType={appToolbarContext.deviceType} {...otherProps}>
        <SelectItem {...selectItemProps} >
          {children}
        </SelectItem>
      </Styled.AppToolbarSelectItem>
    </Tooltip>
  );
}));

AppToolbarSelectItem.defaultProps = {
  tooltipProps: undefined
};

AppToolbarSelectItem.displayName = 'AppToolbarSelectItem';
export default AppToolbarSelectItem;
